/* 🤖 this file was generated by svg-to-ts */
export const iccIconReplay: {
  name: 'replay';
  data: string;
} = {
  name: 'replay',
  data: `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M12 4V0L7 5l5 5V6c3.31 0 6 2.69 6 6s-2.69 6-6 6-6-2.69-6-6H4c0 4.42 3.58 8 8 8s8-3.58 8-8-3.58-8-8-8Z" fill="currentColor"/></svg>`
};
